<template>
  <div @keyup.enter="addChanges">

    <b-row>
      <b-col sm="12">
        <b-card>

          <div slot="header">
            <strong :style="{color: config.primaryColor}">Price Audit API </strong>
            <small :style="{color: config.secondaryColor}"> Filter Form</small>
          </div>

          <b-row>

            <b-col sm="6">
              <b-form-group>
                <label>Store Numbers</label>

                <div>
                  <div class="multiselect__tags-wrap">
                  <span v-for="sn in storeNumbers" :key="sn.value" :style="tagStyles">
                    <span><strong>{{sn}}</strong></span> <i aria-hidden="true" tabindex="1"
                                                            class="multiselect__tag-icon" :style=tagIconStyles
                                                            @click="removeStoreNumber(sn)"></i>
                  </span>
                  </div>
                </div>

                <b-form-input type="text" v-model="storeNumber" placeholder="Store Number"></b-form-input>
                <button @click="addStoreNumber" class="btn btn-sm btn-secondary btn-secondary"
                        :class="{disabled: this.storeNumbers.length >= 5}">Add Store
                </button>
              </b-form-group>
            </b-col>

            <b-col sm="6">
              <b-form-group>
                <label>Product Ids</label>

                <div>
                  <div class="multiselect__tags-wrap">
                  <span v-for="pid in productIds" :key="pid.value" :style="tagStyles">
                    <span><strong>{{pid}}</strong></span> <i aria-hidden="true" tabindex="1"
                                                             class="multiselect__tag-icon" :style=tagIconStyles
                                                             @click="removeProductId(pid)"></i>
                  </span>
                  </div>
                </div>

                <b-form-input type="text" v-model="productId" placeholder="Store Number"></b-form-input>
                <button @click="addProductId" class="btn btn-sm btn-secondary btn-secondary" :class="{disabled: this.productIds.length >= 5}">Add Product Id
                </button>
              </b-form-group>
            </b-col>

          </b-row>


          <b-row>
            <b-col xs="12">
              <div class="form-group form-actions">
                <button @click="getPriceAudit" class="btn btn btn-sm btn-secondary btn-secondary">Run Price Audit</button>
              </div>
            </b-col>
          </b-row>


        </b-card>
      </b-col>
    </b-row>


    <Loading
      :show="loading"
      :label="loadingLabel">
    </Loading>

  </div>
</template>

<script>
  import SSR from './ssr';

  import Loading from 'vue-full-loading';

  export default {
    name: "CompanyPriceAudit",
    mixins: [SSR],
    props: ['config', 'companyId', 'accessToken'],
    components: {Loading},

    data() {
      return {
        audits: [],

        productId: '',
        productIds: [],

        storeNumber: '',
        storeNumbers: [],

        loading: false,
        loadingLabel: "Running Price Audit...",
      }
    },

    methods: {
      addStoreNumber() {
        if (this.storeNumbers.length < 5 && this.storeNumber !== '') {
          this.storeNumbers.push(this.storeNumber);
          this.storeNumber = '';
        }
      },

      addProductId() {
        if (this.productIds.length < 5 && this.productId !== '') {
          this.productIds.push(this.productId);
          this.productId = '';
        }

      },

      removeStoreNumber(storeNumber) {
        this.storeNumbers = this.storeNumbers.filter(sn => sn !== storeNumber);
      },

      removeProductId(productId) {
        this.productIds = this.productIds.filter(pid => pid !== productId);
      },


      getPriceAudit() {
        this.$http.get(`${this.olBaseURL}/price-audit`, {
          headers: this.headers,
          params: this.params,
        }).then(res => {
          console.log(res);
        }, err => {
          console.log(err);
        })
      },

      addChanges() {
        this.addProductId();
        this.addStoreNumber();
      }

    },

    computed: {
      headers() {
        let h = {
          Authorization: `Bearer ${this.accessToken}`,
          "X-Company-Id": this.companyId
        };

        if (this.storeNumbers.length > 0) {
          h["X-Store-Numbers"] = this.commaSepStoreNumbers
        }

        if (this.productIds.length > 0) {
          h["X-Product-Ids"] = this.commaSepProductIds
        }

        return h;
      },

      params() {
        return {}
      },

      commaSepProductIds() {
        return this.productIds.join(',')
      },

      commaSepStoreNumbers() {
        return this.storeNumbers.join(',')
      },

      tagStyles() {
        return {
          position: 'relative',
          display: 'inline-block',
          padding: '4px 26px 4px 10px',
          borderRadius: '5px',
          marginRight: '10px',
          color: this.config.primaryColor,
          lineHeight: 1,
          background: '#FFF',
          marginBottom: '5px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          maxWidth: '100%',
          textOverflow: 'ellipsis'
        }
      },

      tagIconStyles() {
        return {
          cursor: 'pointer',
          marginLeft: '7px',
          position: 'absolute',
          right: 0,
          top: 0,
          bottom: 0,
          color: this.config.secondaryColor,
          fontWeight: 700,
          fontStyle: 'normal',
          width: '22px',
          textAlign: 'center',
          lineHeight: '22px',
          WebkitTransition: 'all .2s ease',
          transition: 'all .2s ease',
          borderRadius: '5px',
        }
      }

    }
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


<style scoped>

  .multiselect__tag-icon:after {
    color: inherit;
  }

  .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
    background: none;
    outline: none;
  }

  .btn {
    margin-top: 15px;
  }


</style>
